import { useState } from "react"
import { useNavigate } from "react-router"
import { useToast } from "@/client/components/common/toast"
import { getBrowserSupabaseClient } from "@/lib/supabase/client"
import { updatePassword } from "@/lib/supabase/auth"
import styles from "./reset-password-page.module.css"

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")
  const [submitting, setSubmitting] = useState(false)
  const toast = useToast()
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (submitting) return

    if (password !== confirm) {
      toast.error("两次密码输入不一致")
      return
    }

    if (password.length < 6) {
      toast.error("密码至少需要6个字符")
      return
    }

    const supabase = getBrowserSupabaseClient()
    if (!supabase) {
      toast.error("系统未配置")
      return
    }

    setSubmitting(true)
    const result = await updatePassword(supabase, password)
    setSubmitting(false)

    if (result.error) {
      toast.error(result.error)
      return
    }

    toast.success("密码重置成功")
    navigate("/me", { replace: true })
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>重置密码</h1>
        <p className={styles.subtitle}>请输入新密码</p>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label className={styles.label}>新密码</label>
          <div className={styles.inputWrapper}>
            <svg className={styles.inputIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
            </svg>
            <input
              className={styles.input}
              type="password"
              placeholder="至少6位密码"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>确认密码</label>
          <div className={styles.inputWrapper}>
            <svg className={styles.inputIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <input
              className={styles.input}
              type="password"
              placeholder="再次输入新密码"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
        </div>

        <button className={styles.submitBtn} type="submit" disabled={submitting}>
          {submitting ? "重置中..." : "确认重置"}
        </button>
      </form>
    </div>
  )
}
